<div class="u-bt u-bt--grey u-pt20">
  <div class="row">
    <div class="col-md-12">
      <h2 class="txt txt--section u-mb30">
        {{numberSection}}. Información licencia
      </h2>
    </div>
  </div>

  <form [formGroup]="controlForm">
    <div class="row">
      <div class="col-md-4">
        <div class="form form--required u-mb20">
          <label for="" class="label">
            Sitio
          </label>
          <h6 class="txt txt--paragraph">
            Selecciona el sitio donde solicitas la licencia.
          </h6>

          <div class="form__radio" *ngFor="let asset of assetList; index as i;">
            <input type="radio" formControlName="assetId" value="{{asset.id}}" id="{{asset.id}}">
            <label for="{{asset.id}}">
              <div class="fakebox"></div>
              {{asset.description}}
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4" *ngIf="!personIsEmployee">
        <div class="form form--required u-mb20">
          <label for="" class="label">
            Contrato <app-tooltip text="Identificador del contrato bajo el cual pedirá la licencia.">
            </app-tooltip>
            <h6 class="txt txt--paragraph">
              Selecciona el contrato asociado a la licencia.
            </h6>
          </label>
          <select formControlName="contractId" id="" [ngClass]="{
            'disable-actions' : controlForm.invalid
          }">
            <option value="0">Selecciona</option>
            <option *ngFor="let contract of contractList; index as i;" value="{{contract.id}}">{{contract.name}}
            </option>
          </select>
        </div>
      </div> -->
      <ng-container *ngIf="controlForm.allErrors">
        <div class="col-md-12 order-md-3 order-2" *ngFor="let error of controlForm.allErrors">
          <div class="form" *ngIf="error?.description">
            <div class="form__error" *ngIf="error?.code == 'haveLicense'">
              <div>
                Esta persona ya tiene una licencia creada en el sitio seleccionado, para registrar un nuevo vehículo
                o
                zona
                debes hacerlo en <a routerLink="/license/extend">Ampliación de licencia</a>.
              </div>
            </div>
            <div class="form__error" *ngIf="error?.code !== 'haveLicense'">
              {{error?.description}}
            </div>
          </div>
        </div>
      </ng-container>

    </div>
  </form>

</div>
